import { render, staticRenderFns } from "./drawer_seeProduct.vue?vue&type=template&id=3fb87928&scoped=true&"
import script from "./drawer_seeProduct.vue?vue&type=script&lang=js&"
export * from "./drawer_seeProduct.vue?vue&type=script&lang=js&"
import style0 from "./drawer_seeProduct.vue?vue&type=style&index=0&id=3fb87928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb87928",
  null
  
)

export default component.exports